export class UserReset2Model {
	password?: string;
	confirmPassword?: string;
	userId?: string;
	resetCode?: string;
	passwordError?: any;
	confirmPasswordError?: any;

	constructor(data: any = {}) {
		this.password = data.password || "";
		this.confirmPassword = data.confirmPassword || "";
		this.userId = data.userId || "";
		this.resetCode = data.resetCode || "";
	}
}
